import heroImage from "../shared/images/heroImage.jpeg";
import aboutImage from "../shared/images/aboutImage.jpeg";
import resumePdf from "../shared/resume/Suyash_Tanwar_resume.pdf";

// Portfolio content extracted from resume + provided assets
export const PROFILE = {
  name: "Suyash Tanwar",
  firstName: "Suyash",
  lastName: "Tanwar",
  title: "Senior Frontend Engineer",
  roles: [
    "Senior Frontend Engineer",
    "React.js Architect",
    "TypeScript Craftsman",
    "AI-Assisted Builder",
  ],
  location: "Indore, India",
  available: true,
  email: "suyashtanwar06@gmail.com",
  phone: "+91 8982462563",
  github: "https://github.com/suyashtanwar06",
  linkedin: "https://www.linkedin.com/in/suyash-tanwar-313455149/",
  instagram: "https://instagram.com/",
  resumeUrl: resumePdf,
  heroImage,
  aboutImage,
  summary:
    "Senior Frontend Engineer with 5+ years of experience building scalable web and mobile applications using React.js, Next.js, TypeScript, and React Native. I specialize in frontend architecture, reusable component systems, API integrations, WCAG accessibility, performance optimization, and internationalization (i18n) — and lean on AI-powered tools like GitHub Copilot and Claude to ship faster without compromising code quality.",
  funFacts: [
    "5+ years shipping production frontends",
    "Worked across Healthcare, Legal-Tech, HRMS & Real-Estate",
    "Cricket fan & music lover",
    "AI-assisted dev evangelist",
  ],
  stats: [
    { value: "5+", label: "Years of Experience" },
    { value: "15+", label: "Enterprise Projects" },
    { value: "4", label: "Industry Domains" },
    { value: "100%", label: "Ownership Mindset" },
  ],
};

export const SKILLS_DATA = [
  {
    category: "Frontend",
    items: [
      { name: "React.js", level: 95 },
      { name: "Next.js", level: 88 },
      { name: "React Native", level: 82 },
      { name: "Redux Toolkit", level: 90 },
      { name: "Tailwind CSS", level: 92 },
      { name: "Material UI", level: 88 },
      { name: "SASS / CSS3", level: 90 },
      { name: "FusionCharts / AmCharts", level: 80 },
    ],
  },
  {
    category: "Languages",
    items: [
      { name: "TypeScript", level: 92 },
      { name: "JavaScript (ES6+)", level: 95 },
      { name: "HTML5", level: 95 },
      { name: "CSS3", level: 92 },
    ],
  },
  {
    category: "Tools",
    items: [
      { name: "Git / GitHub", level: 92 },
      { name: "GitHub Copilot", level: 90 },
      { name: "Jest / RTL", level: 80 },
      { name: "Jira / Agile Scrum", level: 88 },
      { name: "CI/CD", level: 78 },
      { name: "Code Reviews", level: 92 },
    ],
  },
  {
    category: "AI / Gen-AI",
    items: [
      { name: "Claude AI", level: 90 },
      { name: "Prompt Engineering", level: 85 },
      { name: "AI-Assisted Development", level: 92 },
      { name: "Generative AI", level: 80 },
    ],
  },
];

export const EXPERIENCE = [
  {
    id: "infosys",
    company: "Infosys Limited",
    role: "Technology Analyst",
    duration: "Sep 2024 — Present",
    location: "Indore, India",
    bullets: [
      "Lead frontend development for a large-scale healthcare platform using React.js, TypeScript, Material UI and REST APIs.",
      "Built reusable, scalable UI components with full WCAG-compliant accessibility and multilingual (i18n) support.",
      "Integrated multiple APIs and optimized performance to elevate UX and maintainability.",
      "Collaborated with cross-functional Agile teams — PMs, designers, QA and backend engineers.",
      "Leveraged GitHub Copilot & Claude for higher productivity and code quality — earned client recognition for ownership.",
    ],
    stack: ["React.js", "TypeScript", "Material UI", "REST APIs", "i18n", "a11y", "Copilot", "Claude"],
  },
  {
    id: "imenso",
    company: "Imenso Software",
    role: "Software Developer",
    duration: "Feb 2021 — Aug 2024",
    location: "Indore, India",
    bullets: [
      "Built enterprise web & mobile apps using React.js, React Native, TypeScript, Redux and Material UI across multiple domains.",
      "Integrated Google APIs, Firebase, Push Notifications, Maps and Authentication systems.",
      "Created interactive dashboards & advanced visualizations using FusionCharts and AmCharts.",
      "Delivered multiple end-to-end projects independently — from dev to production deployment.",
      "Shipped scalable solutions for healthcare, HRMS, legal-tech, real estate and event management platforms.",
    ],
    stack: ["React.js", "React Native", "TypeScript", "Redux", "Firebase", "FusionCharts", "AmCharts", "Google Maps"],
  },
];

export const PROJECTS = [
  {
    id: "aetna",
    name: "Aetna International",
    category: "Healthcare",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwaGVhbHRoY2FyZSUyMGRhc2hib2FyZCUyMGRhcmt8ZW58MHx8fHwxNzgyNzY3NTMxfDA&ixlib=rb-4.1.0&q=85",
    short:
      "Enterprise healthcare platform — claims management, care services, multilingual support and WCAG-compliant accessibility.",
    long:
      "Led significant frontend modules of a global healthcare platform serving thousands of members. Implemented claims management workflows, care-services integration, language-switching with i18n, and rigorous WCAG 2.1 AA accessibility — including keyboard nav, screen-reader announcements and focus-trapping. Optimized bundle size and API caching to reduce TTFB.",
    stack: ["React.js", "TypeScript", "Material UI", "REST APIs", "i18n", "a11y"],
    role: "Lead Frontend",
  },
  {
    id: "muhakemat",
    name: "Muhakemat Dashboard & Mukavale",
    category: "Legal-Tech",
    image:
      "https://images.unsplash.com/photo-1532190872407-280735d27e08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxsZWdhbCUyMHRlY2hub2xvZ3klMjBhYnN0cmFjdCUyMGRhcmt8ZW58MHx8fHwxNzgyNzY3NTMxfDA&ixlib=rb-4.1.0&q=85",
    short:
      "Data visualization dashboard with 36+ interactive charts, drill-down analytics, advanced filtering and PDF export.",
    long:
      "Designed and shipped a legal-analytics dashboard featuring 36+ interactive FusionCharts/AmCharts visualizations, drill-down navigation, advanced multi-criteria filtering and one-click PDF export. Built a flexible chart-config system so non-engineers could add new views via JSON.",
    stack: ["React.js", "FusionCharts", "AmCharts", "PDF Export"],
    role: "Frontend Engineer",
  },
  {
    id: "ultron",
    name: "Ultron HRMS",
    category: "HRMS",
    image:
      "https://images.unsplash.com/photo-1481151500463-1fa2dd2d5dbe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBIUiUyMGNvcnBvcmF0ZSUyMG9mZmljZSUyMGRhcmt8ZW58MHx8fHwxNzgyNzY3NTMxfDA&ixlib=rb-4.1.0&q=85",
    short:
      "Enterprise HR system — attendance, payroll, leave, project tracking and workforce analytics.",
    long:
      "Delivered an enterprise HR platform with attendance, payroll, leave management, project tracking and workforce analytics dashboards. Implemented role-based access, granular permissions and audit logging.",
    stack: ["React.js", "Redux", "REST APIs", "Charts"],
    role: "Frontend Engineer",
  },
  {
    id: "team-organizer",
    name: "Team Organizer",
    category: "Cross-Platform",
    image:
      "https://images.unsplash.com/photo-1615803697515-3cb782c2a65a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx0ZWFtJTIwY29sbGFib3JhdGlvbiUyMHdvcmtzcGFjZSUyMGRhcmt8ZW58MHx8fHwxNzgyNzY3NTMxfDA&ixlib=rb-4.1.0&q=85",
    short:
      "Cross-platform team & event management app — collaboration, scheduling, notifications and a custom calendar.",
    long:
      "Built a unified web + mobile team management app using shared business logic across React.js and React Native. Implemented a custom calendar, real-time push notifications via Firebase and granular event scheduling.",
    stack: ["React.js", "React Native", "Firebase", "Push Notifications"],
    role: "Full Stack Frontend",
  },
  {
    id: "mama-agent",
    name: "Mama Agent",
    category: "Real Estate",
    image:
      "https://images.unsplash.com/photo-1565043534426-8a67ac8671e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxyZWFsJTIwZXN0YXRlJTIwbW9kZXJuJTIwYnVpbGRpbmclMjBkYXJrJTIwbmlnaHR8ZW58MHx8fHwxNzgyNzY3NTMxfDA&ixlib=rb-4.1.0&q=85",
    short:
      "Real-estate marketplace — listings, role-based access, Google Maps integration and 3D property visualization.",
    long:
      "Built a real-estate marketplace with property listings, role-based access control (buyer/agent/admin), Google Maps integration, and 3D property visualizations.",
    stack: ["React.js", "Google Maps", "3D Visualization"],
    role: "Frontend Engineer",
  },
];

export const EDUCATION = [
  {
    id: "be",
    degree: "Bachelor of Engineering",
    university: "Sushila Devi Bansal College of Engineering",
    location: "Indore, India",
    dates: "2016 — 2020",
  },
];

export const CERTIFICATIONS = [
  {
    id: "infosys-gen-ai",
    name: "Infosys Certified Generative AI Professional",
    issuer: "Infosys",
    year: "2025",
  },
  {
    id: "responsible-ai",
    name: "Fundamentals of Responsible AI",
    issuer: "Infosys",
    year: "2025",
  },
  {
    id: "testdome",
    name: "TestDome Certificate",
    issuer: "TestDome",
    year: "2023",
    url: "https://www.testdome.com/certificates/edc46d2e2def43409052d6134553e5b1",
  },
];

export const ACHIEVEMENTS = [
  "Client recognition for ownership & timely delivery at Infosys",
  "Led WCAG accessibility implementation across enterprise modules",
  "Built 36+ interactive analytics charts in production",
  "Shipped applications across 5+ verticals end-to-end",
];

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "skills", label: "Skills" },
  { id: "experience", label: "Experience" },
  { id: "projects", label: "Projects" },
  { id: "education", label: "Education" },
  { id: "contact", label: "Contact" },
];

export const MARQUEE_TECH = [
  "React.js",
  "Next.js",
  "TypeScript",
  "React Native",
  "Redux Toolkit",
  "Tailwind CSS",
  "Material UI",
  "FusionCharts",
  "AmCharts",
  "Firebase",
  "GitHub Copilot",
  "Claude AI",
  "WCAG a11y",
  "i18n",
];
